import React from 'react';
import { Box } from '@nimbus-ds/components';
import { useIsMobile } from 'commons/hooks';

interface BaseAppLayoutInterface {
  children: React.ReactNode;
  maxWidth?: string;
}

function BaseAppLayout(props: BaseAppLayoutInterface): JSX.Element {
  const isMobile = useIsMobile();

  return (
    <Box
      minHeight="100vh"
      display="flex"
      height="100%"
      backgroundColor={isMobile ? 'neutral-background' : 'neutral-surface'}
    >
      <Box
        maxWidth={props.maxWidth ?? '1200px'}
        flex="1"
        marginX="auto"
        display="flex"
        flexDirection="column"
        alignItems="stretch"
        gap="4"
        padding="6"
      >
        {props.children}
      </Box>
    </Box>
  );
}

export default BaseAppLayout;
